import types from '../actionTypes';

const INITIAL_STATE = {
  isFetchingParkingTemplate : false,
  templates: [],
  errors: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.PARKING_TEMPLATE_FETCH_REQUEST:
      return {
        ...state,
        isFetchingParkingTemplate: true,
      };
    case types.PARKING_TEMPLATE_FETCH_SUCCESS:
      return {
        ...state,
        isFetchingParkingTemplate: false,
        templates: action.payload.parkingTemplate,
      };
    case types.PARKING_TEMPLATE_FETCH_FAIL:
      return {
        ...state,
        isFetchingParkingTemplate: false,
        errors: action.payload.error,
      };
    default:
      return state;
  }
};
